import { styled } from 'baseui'

export const FeedbackButton = styled('button', ({ $active, disabled }) => ({
  flex: 1,
  padding: '0.75rem 0',
  borderRadius: '0.5rem',
  border: '0.0625rem solid #D0D0D0',
  backgroundColor: $active ? '#F5F8FC' : '#FFFFFF',
  fontSize: '0.875rem',
  fontWeight: 500,
  cursor: disabled ? 'not-allowed' : 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.5rem',
  opacity: disabled ? 0.5 : 1,
  filter: disabled ? 'grayscale(70%) brightness(0.93)' : 'none',
  background: disabled ? '#F1F3F7' : ($active ? '#F5F8FC' : '#FFFFFF'),
  color: disabled ? '#8A8A8A' : '#2C2C2C',
  borderColor: disabled ? '#D0D0D0' : '#D0D0D0',
}))

export const QuestionText = styled('p', {
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#2C2C2C',
  margin: '0.75rem 0 0.25rem',
})

export const FeedbackButtonsRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '1rem',
  width: '100%',
})

export const SuccessContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2rem',
  paddingTop: '2rem',
  paddingBottom: '1rem',
})

export const SuccessMessage = styled('p', {
  fontSize: '1.125rem',
  fontWeight: '600',
  color: '#0F9D58',
  lineHeight: '1.5rem',
  textAlign: 'center',
  marginTop: '1rem',
})